// extracted by mini-css-extract-plugin
export var copy = "Footer-module--copy--06a13";
export var creator = "Footer-module--creator--c8e94";
export var illustration = "Footer-module--illustration--dd62d";
export var root = "Footer-module--root--8f2b9";
export var stroke = "Footer-module--stroke--b24ac";